import { FliptClient, ErrorStrategy } from "@flipt-io/flipt-client-js";
import { FeatureFlag } from "./FeatureFlags";

export class FliptService {
  private client: FliptClient;

  private constructor(client: FliptClient) {
    this.client = client;
  }

  static async create(url: string, environment: string, namespace: string): Promise<FliptService> {
    const client = await FliptClient.init({
      url,
      namespace,
      environment,
      errorStrategy: ErrorStrategy.Fallback,
      // Flag snapshot is loaded once at init and not refreshed — flags are static for the session lifetime.
      updateInterval: 0,
    });
    return new FliptService(client);
  }

  evaluate(flag: FeatureFlag, context?: Record<string, string>): boolean {
    try {
      // Static entityId — per-user targeting (percentage rollouts) is not supported yet.
      // The SDK requires a non-empty entityId, so we use a fixed placeholder.
      const request = { flagKey: flag, entityId: "default", context: context ?? {} };
      const result = this.client.evaluateBoolean(request);
      return result.enabled;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("[FliptService] evaluate error", flag, e);
      return false;
    }
  }
}
